import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchVirtualDevices';
import { validImageFileName } from '../../../utils/vuex';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import 'codemirror/mode/markdown/markdown.js';
export default {
  name: 'CoreVirtualDeviceSmartGroupsMetaEdit',
  components: {
    MarkdownItVueLight: MarkdownItVueLight
  },
  mixins: [multiSearchMixin],
  props: {
    smartGroup: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      editModel: null,
      markdownEdit: false,
      valid: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    saveDisabled: function saveDisabled() {
      return !this.selectedAccount || !this.viewTitle || !this.searchItems.length;
    },
    filteredSearchTypes: function filteredSearchTypes() {
      return this.searchTypes.filter(function (type) {
        return type.param !== 'health' && type.param !== 'zone';
      });
    },
    selectedAttachments: function selectedAttachments() {
      if (this.editModel.meta && this.editModel.meta.viewImageId) {
        return [this.editModel.meta.viewImageId];
      }

      return [];
    },
    viewImages: function viewImages() {
      return [{
        name: this.$i18n_t('DigitalTwin.DigitalTwin.states.dataSources.none'),
        id: null
      }].concat((this.editModel.meta && this.editModel.meta.attachments || []).filter(function (attachment) {
        return validImageFileName(attachment.name);
      }));
    },
    packetMonitoringInterval: function packetMonitoringInterval() {
      return [{
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_HOUR'),
        value: 60
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_DAY'),
        value: 1440
      }, {
        text: this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.timeRange.items.LAST_WEEK'),
        value: 10080
      }];
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    }
  }),
  watch: {
    smartGroup: {
      handler: function handler() {
        this.initEditItem(cloneDeep(this.smartGroup));
      },
      deep: true,
      immediate: true
    },
    editModel: {
      handler: function handler() {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.smartGroup)) {
          this.publishChanges();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.open();
  },
  methods: {
    initEditItem: function () {
      var _initEditItem = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(smartGroup) {
        var _this2 = this;

        var viewConfig, search, sanitizedSearchItems;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (smartGroup) {
                  this.editModel = cloneDeep(_objectSpread(_objectSpread({}, smartGroup), {}, {
                    meta: _objectSpread(_objectSpread({}, get(smartGroup, 'meta') || {}), {}, {
                      monitoring: _objectSpread({}, get(smartGroup, 'meta.monitoring') || {
                        threshold: 3000,
                        interval: 60,
                        type: 'warning'
                      })
                    })
                  }));
                }

                viewConfig = (this.editModel || {}).viewConfig || {};
                search = viewConfig.searchItems || [];
                _context2.next = 5;
                return Promise.all(search.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
                    var customSearchHandler, devices, _devices;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(item.variable === 'deviceDriver')) {
                              _context.next = 8;
                              break;
                            }

                            customSearchHandler = _this2.searchTypes.find(function (type) {
                              return type.param === item.variable;
                            }).searchHandler;
                            _context.next = 4;
                            return customSearchHandler(item.search);

                          case 4:
                            devices = _context.sent;

                            if (!(!devices || devices.length === 0)) {
                              _context.next = 7;
                              break;
                            }

                            return _context.abrupt("return", null);

                          case 7:
                            return _context.abrupt("return", {
                              param: item.variable,
                              search: {
                                value: item.search,
                                text: devices.find(function (device) {
                                  return device.value === item.search;
                                }).text
                              }
                            });

                          case 8:
                            if (!(item.variable === 'deviceType')) {
                              _context.next = 13;
                              break;
                            }

                            _devices = _this2.searchTypes.find(function (type) {
                              return type.param === item.variable;
                            }).items;

                            if (!(!_devices || _devices.length === 0)) {
                              _context.next = 12;
                              break;
                            }

                            return _context.abrupt("return", null);

                          case 12:
                            return _context.abrupt("return", {
                              param: item.variable,
                              search: {
                                value: item.search,
                                text: _devices.find(function (device) {
                                  return device.value === item.search;
                                }).text
                              }
                            });

                          case 13:
                            if (!(item.variable === 'operationalStatus')) {
                              _context.next = 15;
                              break;
                            }

                            return _context.abrupt("return", {
                              param: item.variable,
                              search: {
                                value: item.search,
                                text: _this2.operationalStatus[item.search]
                              }
                            });

                          case 15:
                            return _context.abrupt("return", {
                              param: item.variable,
                              search: item.search
                            });

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 5:
                sanitizedSearchItems = _context2.sent;
                _context2.next = 8;
                return sanitizedSearchItems.filter(function (i) {
                  return i !== null;
                });

              case 8:
                this.searchItems = _context2.sent;
                this.searchOperator = viewConfig.searchOperator;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initEditItem(_x) {
        return _initEditItem.apply(this, arguments);
      }

      return initEditItem;
    }(),
    searchUpdated: function searchUpdated(searchItems, operator) {
      this.searchItems = searchItems; // defined in multiSearchMixin

      this.searchOperator = operator; // defined in multiSearchMixin
    },
    attachmentsUpdated: function attachmentsUpdated(data) {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }

      this.editModel.meta.attachments = data;
    },
    viewImageSelected: function viewImageSelected(item) {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }

      this.editModel.meta.viewImageId = item.id;
    },
    viewImageDeselected: function viewImageDeselected() {
      if (!this.editModel.meta) {
        this.editModel.meta = {};
      }

      delete this.editModel.meta.viewImageId;
    },
    open: function open() {
      // should this be called every time the dialog opens?
      this.getMultiFilterData(); // defined in multiSearchMixin
    },
    createRequestOptions: function createRequestOptions() {
      return _objectSpread(_objectSpread({}, this.editModel), {}, {
        // meta: null, // meta is included in the docs, but API throws 400 when used
        viewConfig: {
          searchItems: this.searchItems.map(function (item) {
            return {
              variable: item.param,
              // support item.search.value === null, so do not simply have a >search.value || search< expression
              search: (item.search || {}).value === undefined ? item.search : item.search.value
            };
          }),
          searchOperator: this.searchOperator,
          filters: [{
            type: 'tenantIds',
            ids: [this.editModel.tenantId]
          }],
          options: null
        }
      });
    },
    save: function save() {
      var params = this.createRequestOptions();
      this.$emit('save', params);
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};